import styles from "./tag.module.css";

export default function Tag(props) {
  const { text } = props;
  return <div className={styles.tag}>{text}</div>;
}
